module.exports = __webpack_public_path__ + "img/rate.744d6bf8.png";